// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/img/header/base-ondas.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  display: flex;
  height: 220px;
  padding: 10px 0;
  justify-content: space-between;
  align-items: center;
  z-index: 999;
  background: linear-gradient(to left, #56bfc9, #24a637 65%) !important;
}

.bg-header {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bg-header .brand {
  margin: 50px 0 !important;
  display: flex;
  align-items: center;
}
.bg-header .brand .service-name {
  color: #fff;
  border-right: 1px solid #fff;
  padding-right: 15px;
  margin-bottom: 0px;
  font-weight: bold;
  font-size: 35px !important;
}
.bg-header .brand img {
  margin-left: 10px;
  height: 85px;
}

.header-actions {
  display: flex;
  align-items: center;
}
.header-actions ul {
  display: flex;
  margin: 0;
  width: 500px;
}
.header-actions ul li {
  list-style: none;
}
.header-actions ul li a {
  font-size: 12px;
  text-decoration: none;
  color: #fff;
  padding-right: 10px;
  padding-left: 10px;
  font-weight: bold;
  height: 15px;
  display: flex;
  align-items: center;
  border-right: 3px solid #ffbd00;
}
.header-actions ul li a span {
  text-transform: uppercase;
}
.header-actions ul li a img {
  margin-right: 10px;
  height: 36px;
}
.header-actions ul li a:hover {
  color: #ffbd00;
}
.header-actions li:last-child a {
  border-right: none;
  padding-right: 0 !important;
}

.bg-header-overlay {
  width: 100%;
  position: absolute;
  bottom: 0;
  z-index: 999 !important;
  height: 75px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 0px bottom transparent !important;
  background-position: bottom left;
  background-repeat: no-repeat;
  background-size: 35% auto;
  display: flex;
  flex-direction: row;
  justify-content: right;
  align-items: center;
}

@media (max-width: 480px) {
  .bg-header {
    height: 130px !important;
    padding: 0 !important;
    display: flex;
    justify-content: bottom;
  }
  .bg-header .brand {
    align-self: flex-end;
    display: flex;
    align-items: flex-end;
    margin: 0 !important;
  }
  .bg-header .brand .service-name {
    font-size: 0.6rem !important;
    text-align: center;
    position: relative;
    border: none;
  }
  .bg-header .brand .service-name::after {
    content: "";
    top: 6px;
    right: 0;
    margin: auto 0;
    position: absolute;
    width: 0.1px;
    height: 18px;
    background-color: white;
  }
  .bg-header .brand img {
    height: 30px !important;
  }
  .bg-header-overlay {
    height: 55px !important;
  }
  .bg-header-overlay .header-actions ul {
    width: 100% !important;
  }
  .bg-header-overlay .header-actions ul li a {
    border: none !important;
    height: auto;
  }
  .bg-header-overlay .header-actions ul li a img {
    height: 15px;
  }
  .bg-header-overlay .header-actions ul li a span {
    font-size: 0.7rem;
  }
}
@media (min-width: 480px) and (max-width: 1400px) {
  .bg-header {
    width: 100% !important;
  }
  .bg-header .brand {
    width: 100% !important;
    display: flex !important;
    justify-content: center !important;
  }
  .bg-header .brand .service-name {
    font-size: 1rem !important;
    text-align: center;
    position: relative;
  }
  .bg-header .brand img {
    height: 45px !important;
  }
  .bg-header-overlay {
    height: 60px !important;
  }
  .bg-header-overlay .header-actions {
    width: 100%;
    margin: auto 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/UI/Header/header.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,qEAAA;AADF;;AAIA;EACE,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADF;AAGE;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;AADJ;AAGI;EACE,WAAA;EACA,4BAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,0BAAA;AADN;AAGI;EACE,iBAAA;EACA,YAAA;AADN;;AAMA;EACE,aAAA;EACA,mBAAA;AAHF;AAIE;EACE,aAAA;EACA,SAAA;EACA,YAAA;AAFJ;AAGI;EACE,gBAAA;AADN;AAEM;EACE,eAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,+BAAA;AAAR;AACQ;EACE,yBAAA;AACV;AACQ;EACE,kBAAA;EACA,YAAA;AACV;AAEM;EACE,cAAA;AAAR;AAKI;EACE,kBAAA;EACA,2BAAA;AAHN;;AAQA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,uBAAA;EACA,YAAA;EACA,+FAAA;EAEA,gCAAA;EACA,4BAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;AANF;;AASA;EACE;IACE,wBAAA;IACA,qBAAA;IACA,aAAA;IACA,uBAAA;EANF;EAQE;IACE,oBAAA;IACA,aAAA;IACA,qBAAA;IACA,oBAAA;EANJ;EAQI;IACE,4BAAA;IACA,kBAAA;IACA,kBAAA;IACA,YAAA;EANN;EAQM;IACE,WAAA;IACA,QAAA;IACA,QAAA;IACA,cAAA;IACA,kBAAA;IACA,YAAA;IACA,YAAA;IACA,uBAAA;EANR;EASI;IACE,uBAAA;EAPN;EAYA;IACE,uBAAA;EAVF;EAaI;IACE,sBAAA;EAXN;EAaQ;IACE,uBAAA;IACA,YAAA;EAXV;EAaU;IACE,YAAA;EAXZ;EAaU;IACE,iBAAA;EAXZ;AACF;AAmBA;EACE;IACE,sBAAA;EAjBF;EAmBE;IACE,sBAAA;IACA,wBAAA;IACA,kCAAA;EAjBJ;EAkBI;IACE,0BAAA;IACA,kBAAA;IACA,kBAAA;EAhBN;EAkBI;IACE,uBAAA;EAhBN;EAqBA;IACE,uBAAA;EAnBF;EAqBE;IACE,WAAA;IACA,cAAA;EAnBJ;AACF","sourcesContent":["@import '../../../styles/colors.scss';\n\n.main {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  display: flex;\n  height: 220px;\n  padding: 10px 0;\n  justify-content: space-between;\n  align-items: center;\n  z-index: 999;\n  background: linear-gradient(to left, #56bfc9, #24a637 65%) !important;\n}\n\n.bg-header {\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  .brand {\n    margin: 50px 0 !important;\n    display: flex;\n    align-items: center;\n\n    .service-name {\n      color: #fff;\n      border-right: 1px solid #fff;\n      padding-right: 15px;\n      margin-bottom: 0px;\n      font-weight: bold;\n      font-size: 35px !important;\n    }\n    img {\n      margin-left: 10px;\n      height: 85px;\n    }\n  }\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  ul {\n    display: flex;\n    margin: 0;\n    width: 500px;\n    li {\n      list-style: none;\n      a {\n        font-size: 12px;\n        text-decoration: none;\n        color: #fff;\n        padding-right: 10px;\n        padding-left: 10px;\n        font-weight: bold;\n        height: 15px;\n        display: flex;\n        align-items: center;\n        border-right: 3px solid #ffbd00;\n        span {\n          text-transform: uppercase;\n        }\n        img {\n          margin-right: 10px;\n          height: 36px;\n        }\n      }\n      a:hover {\n        color: #ffbd00;\n      }\n    }\n  }\n  li:last-child {\n    a {\n      border-right: none;\n      padding-right: 0 !important;\n    }\n  }\n}\n\n.bg-header-overlay {\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  z-index: 999 !important;\n  height: 75px;\n  background: url(../../../assets/img/header/base-ondas.svg) no-repeat 0px\n    bottom transparent !important;\n  background-position: bottom left;\n  background-repeat: no-repeat;\n  background-size: 35% auto;\n  display: flex;\n  flex-direction: row;\n  justify-content: right;\n  align-items: center;\n}\n\n@media (max-width: 480px) {\n  .bg-header {\n    height: 130px !important;\n    padding: 0 !important;\n    display: flex;\n    justify-content: bottom;\n\n    .brand {\n      align-self: flex-end;\n      display: flex;\n      align-items: flex-end;\n      margin: 0 !important;\n\n      .service-name {\n        font-size: 0.6rem !important;\n        text-align: center;\n        position: relative;\n        border: none;\n\n        &::after {\n          content: '';\n          top: 6px;\n          right: 0;\n          margin: auto 0;\n          position: absolute;\n          width: 0.1px;\n          height: 18px;\n          background-color: white;\n        }\n      }\n      img {\n        height: 30px !important;\n      }\n    }\n  }\n\n  .bg-header-overlay {\n    height: 55px !important;\n\n    .header-actions {\n      ul {\n        width: 100% !important;\n        li {\n          a {\n            border: none !important;\n            height: auto;\n\n            img {\n              height: 15px;\n            }\n            span {\n              font-size: 0.7rem;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (min-width: 480px) and (max-width: 1400px) {\n  .bg-header {\n    width: 100% !important;\n\n    .brand {\n      width: 100% !important;\n      display: flex !important;\n      justify-content: center !important;\n      .service-name {\n        font-size: 1rem !important;\n        text-align: center;\n        position: relative;\n      }\n      img {\n        height: 45px !important;\n      }\n    }\n  }\n\n  .bg-header-overlay {\n    height: 60px !important;\n\n    .header-actions {\n      width: 100%;\n      margin: auto 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
